import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/EV.com/EV.com/frontend/src/app/AppWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorTemplate"] */ "/home/runner/work/EV.com/EV.com/frontend/src/components/template/ErrorTemplate/ErrorTemplate.tsx");
